/**
 * WhatsApp del negocio.
 *
 * Se pasó del short link (`wa.me/message/<código>`) al formato con número el
 * 2026-09-15. Motivo: el mensaje del carrito es largo y multilínea, y el formato
 * con número es el documentado por WhatsApp — el short link trae su propio
 * mensaje configurado en el perfil del negocio y no garantiza respetar `?text=`.
 *
 * Contrapartida asumida y avisada al cliente: el número queda en el bundle
 * público y lo pueden scrapear bots de spam, cosa que el short link no permitía.
 * Ya era alcanzable (el short link abre este mismo chat) y es el número con el
 * que el negocio vende. Revertir es cambiar estas dos constantes.
 */
export const WHATSAPP_NUMERO = "525586126150";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMERO}`;
export const INSTAGRAM_URL = "https://www.instagram.com/odyscents_/";
/**
 * Logo oficial que entregó la clienta el 2026-09-23 (negro y dorado sobre crema),
 * convertido para el fondo negro del sitio: sin fondo, y la tinta negra pasada a
 * marfil — sobre #050505 la "O" y el texto negros desaparecían. El script que lo
 * genera y el original están en el run ICM `2026-09-23-logo-nuevo` del hub.
 *
 * Dos piezas y no una: a 44 px el lockup completo es ilegible, así que el menú y el
 * pie usan solo el monograma "OS" (al lado va el nombre en texto).
 *
 * Se sirven desde el propio sitio (`public/brand/`), no desde R2: viajan versionados
 * con el código y un deploy los cambia junto con el JSX que los usa. El logo
 * anterior (`img.odyscents.com/brand/logo.webp`) sigue en R2, sin usar.
 */
export const LOGO_MONOGRAMA = "/brand/logo-monograma.webp";
export const LOGO_COMPLETO = "/brand/logo-completo.webp";

export const waLink = (text) =>
  `${WHATSAPP_URL}?text=${encodeURIComponent(text)}`;

export const HERO_IMG =
  "https://images.unsplash.com/photo-1588405748880-12d1d2a59f75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwZXJmdW1lJTIwYWVzdGhldGljJTIwZGFya3xlbnwwfHx8fDE3ODI4NTMzNDd8MA&ixlib=rb-4.1.0&q=85";

export const PRODUCTS = [
  {
    id: "sauvage",
    brand: "Dior",
    name: "Sauvage",
    note: "Amaderado · Especiado",
    gender: "Hombre",
    img: "https://images.unsplash.com/photo-1698867928110-2408e8e2f44a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxkaW9yJTIwc2F1dmFnZSUyMHBlcmZ1bWV8ZW58MHx8fHwxNzgyODUzMzM3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "valentino",
    brand: "Valentino",
    name: "Uomo Intense",
    note: "Oriental · Vainilla",
    gender: "Hombre",
    img: "https://images.unsplash.com/photo-1705338670422-01133208eab9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx2YWxlbnRpbm8lMjBwZXJmdW1lJTIwZGFya3xlbnwwfHx8fDE3ODI4NTMzMzd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "gentleman",
    brand: "Givenchy",
    name: "Gentleman",
    note: "Amaderado · Iris",
    gender: "Hombre",
    img: "https://images.unsplash.com/photo-1780943004155-1b2c5424fb2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwZXJmdW1lJTIwYm90dGxlJTIwZGFyayUyMGRyYW1hdGljfGVufDB8fHx8MTc4Mjg1MzQwOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "mancera",
    brand: "Mancera",
    name: "French Riviera",
    note: "Cítrico · Floral",
    gender: "Unisex",
    img: "https://images.unsplash.com/photo-1615160460366-2c9a41771b51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwZXJmdW1lJTIwZGFyayUyMGJvdHRsZSUyMGdvbGR8ZW58MHx8fHwxNzgyODUzMzM4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "marly",
    brand: "Parfums de Marly",
    name: "Layton",
    note: "Especiado · Manzana",
    gender: "Unisex",
    img: "https://images.unsplash.com/photo-1733660227163-01bc46e0d7d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxwZXJmdW1lJTIwYWVzdGhldGljJTIwZGFya3xlbnwwfHx8fDE3ODI4NTMzNDd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "jpg",
    brand: "Jean Paul Gaultier",
    name: "Le Beau",
    note: "Fresco · Coco",
    gender: "Hombre",
    img: "https://images.unsplash.com/photo-1556262965-c3cbb1cfadf8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwcGVyZnVtZSUyMGdvbGQlMjBibGFjayUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3ODI4NTM0MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "poison",
    brand: "Dior",
    name: "Poison Girl",
    note: "Dulce · Floral",
    gender: "Mujer",
    img: "https://images.unsplash.com/photo-1618606778342-de0ee275b389?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwcGVyZnVtZSUyMGdvbGQlMjBibGFjayUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3ODI4NTM0MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "noir",
    brand: "Edición",
    name: "Noir Privée",
    note: "Ámbar · Oud",
    gender: "Unisex",
    img: "https://images.unsplash.com/photo-1543857261-f71238eb4188?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwcGVyZnVtZSUyMGdvbGQlMjBibGFjayUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3ODI4NTM0MDh8MA&ixlib=rb-4.1.0&q=85",
  },
];
